import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BookOpenIcon, EnvelopeIcon, BuildingOffice2Icon, ArrowLeftIcon } from '@heroicons/react/24/outline';
import { safeErrorMessage } from '../utils/apiError';
import styles from './Login.module.css';

function ForgotPassword() {
  const [schoolSlug, setSchoolSlug] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/v1/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ school_slug: schoolSlug.trim(), email: email.trim() }),
      });
      if (response.ok) {
        const data = await response.json();
        setMessage(data.message);
        setSubmitted(true);
      } else {
        setError(await safeErrorMessage(response, 'Something went wrong. Please try again.'));
      }
    } catch (err) {
      setError('Network error. Is the backend running?');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.iconWrap}>
            <BookOpenIcon className={styles.icon} />
          </div>
          <h1 className={styles.title}>Forgot Password</h1>
          <p className={styles.subtitle}>We'll email you a link to reset it.</p>
        </div>

        {error && <div className={styles.error}>{error}</div>}
        {message && <div className={styles.success}>{message}</div>}

        {!submitted && (
          <form onSubmit={handleSubmit}>
            <div className={styles.field}>
              <label className={styles.label}>School Code</label>
              <div className={styles.inputWrap}>
                <BuildingOffice2Icon className={styles.inputIcon} />
                <input
                  type="text"
                  value={schoolSlug}
                  onChange={(e) => setSchoolSlug(e.target.value)}
                  required
                  placeholder="e.g. default"
                  className={styles.input}
                  autoCapitalize="none"
                  autoCorrect="off"
                />
              </div>
            </div>

            <div className={styles.field}>
              <label className={styles.label}>Email</label>
              <div className={styles.inputWrap}>
                <EnvelopeIcon className={styles.inputIcon} />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="you@example.com"
                  className={styles.input}
                />
              </div>
            </div>

            <button type="submit" className={styles.submitBtn} disabled={loading}>
              {loading ? (
                <>
                  <span className={styles.spinner} />
                  Sending...
                </>
              ) : (
                'Send Reset Link'
              )}
            </button>
          </form>
        )}

        <p className={styles.linkRow}>
          <Link to="/" className={styles.link}>
            <ArrowLeftIcon style={{ width: 12, height: 12, display: 'inline', marginRight: 4 }} />
            Back to login
          </Link>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
